'use client';

import { CurrencySwitcher } from '@/components/ui/currency-switcher';

interface CurrencyNavbarProps {
  className?: string;
  position?: 'sticky' | 'fixed' | 'relative' | 'static';
  showBorder?: boolean;
}

export function CurrencyNavbar({ 
  className = '', 
  position = 'sticky',
  showBorder = true 
}: CurrencyNavbarProps) {
  const positionClasses = {
    sticky: 'sticky top-16',
    fixed: 'fixed top-16',
    relative: 'relative',
    static: 'static'
  };

  return (
    <nav 
      className={`w-full bg-gray-50 ${positionClasses[position]} ${className}`}
      data-component="currency-navbar"
      role="navigation"
      aria-label="Currency navigation"
      style={{ zIndex: 'var(--z-currency-navbar)' }}
    >
      <div className="container mx-auto max-w-8xl px-2 lg:px-1">
        {/* Desktop Version */}
        <div className="hidden lg:flex h-12 items-center justify-end">
          <div className="relative">
            <CurrencySwitcher variant="desktop" />
          </div>
        </div>

        {/* Mobile Version */}
        <div className="lg:hidden h-12 flex items-center justify-end px-4">
          <CurrencySwitcher variant="desktop" />
        </div>
      </div>
      
      {/* Optional Border */}
      {showBorder && (
        <div className="h-[0.5px] w-full border-t border-[#CCD2D9]" />
      )}
    </nav>
  );
}

// Alternative minimal version without container wrapper
export function CurrencyNavbarMinimal({ 
  className = '',
  alignment = 'right'
}: { 
  className?: string;
  alignment?: 'left' | 'center' | 'right';
}) {
  const alignmentClasses = {
    left: 'justify-start',
    center: 'justify-center', 
    right: 'justify-end'
  };

  return (
    <nav 
      className={`w-full bg-white p-4 ${className}`}
      role="navigation"
      aria-label="Currency navigation"
    >
      {/* Desktop Version */}
      <div className={`hidden lg:flex ${alignmentClasses[alignment]}`}>
        <div className="relative">
          <CurrencySwitcher variant="desktop" />
        </div>
      </div>

      {/* Mobile Version */}
      <div className="lg:hidden">
        <CurrencySwitcher variant="mobile" />
      </div>
    </nav>
  );
} 